import { message } from 'antd';

export const MessageTypes = {
    SUCCESS: 'success',
    ERROR: 'error',
    WARNING: 'warning'
}
export function displayMessage(type, m) {
    message[type](m);
}